import { FaWhatsapp } from 'react-icons/fa';
import { FiPhone } from 'react-icons/fi';
import { SITE } from '@maktech/shared';

/**
 * WhatsApp + call float buttons (spec 7.2).
 *
 * Ported from waUs()/callUs() (index.html:3969/:3968). callUs() only raised a
 * toast; a tel: link actually dials, which is the real intent on the mobile
 * traffic this serves.
 */
export function ContactFloats() {
  return (
    <div className="fixed right-[18px] bottom-[18px] z-[60] flex flex-col gap-2.5 max-sm:right-3 max-sm:bottom-3" aria-label="Contact us">
      <a
        className="flex size-[52px] items-center justify-center rounded-full bg-[#25d366] text-[22px] text-white no-underline shadow-[0_6px_20px_rgba(15,12,10,.22)] transition-transform duration-[120ms] hover:-translate-y-0.5 max-sm:size-[46px] max-sm:text-[19px]"
        data-testid="float-whatsapp"
        href={`https://wa.me/${SITE.whatsapp}`}
        target="_blank"
        rel="noreferrer"
        aria-label={`WhatsApp +${SITE.whatsapp}`}
        title={`WhatsApp +${SITE.whatsapp}`}
      >
        <FaWhatsapp className="size-6" aria-hidden />
      </a>
      <a
        className="flex size-[52px] items-center justify-center rounded-full bg-[var(--cobalt)] text-[22px] text-white no-underline shadow-[0_6px_20px_rgba(15,12,10,.22)] transition-transform duration-[120ms] hover:-translate-y-0.5 max-sm:size-[46px] max-sm:text-[19px]"
        data-testid="float-call"
        href={`tel:+${SITE.whatsapp}`}
        aria-label={`Call ${SITE.hotline}`}
        title={`Call ${SITE.hotline}`}
      >
        <FiPhone className="size-6" aria-hidden />
      </a>
    </div>
  );
}
